<template>
  <div class="app-container">
    <list ref="list">
      <!-- <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" class="filter-item" type="primary" @click="create">添加</el-button>
        <el-button size="mini" class="filter-item" type="danger" @click="delRows">删除</el-button>
      </template>
      <el-table-column
        slot="column"
        v-if="$permission.canWrite()"
        label="操作"
        fixed="right"
        align="center"
        :width="isMB?'60':'90'"
      >
        <template slot-scope="{row}">
          <el-button type="text" @click="editById(row.PhoneId)">编辑</el-button>
        </template>
      </el-table-column> -->
    </list>
    <!-- <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/consume/statistics/list";
// import editDialog from "@/components/consume/phonemanage/editDialog";

export default {
  name: "statistics",
  mixins: [curdMixins],
  components: {
    list,
    // editDialog,
  },
  data() {
    return {
      // api: require("@/api/consume/phonemanage").default,
      isMB: this.$store.state.isMB,
    }
  },
  methods: {

  },
};
</script>